import { v4 } from "uuid";

import { IAppointmentActionResponseDto } from "modules/appointment/Dtos/IAppointmentActionResponseDto";
import { Status } from "modules/queues/types/Status";

export const createAppointmentActionResponse = (
  response?: IAppointmentActionResponseDto
): IAppointmentActionResponseDto => {
  return {
    id: v4(),
    startDate: "2021-02-21 9:30",
    endDate: "2021-02-21 9:45",
    createDate: "2021-02-21 9:00",
    status: Status.Active,
    email: "user@test.pl",
    queueId: "aaaa-bbbb-gggg-1",
    emailSuccessfullySent: true,
    cancellationReason: "cancellation reason",
    ...response,
  };
};
